/**
 * Query used to fetch all users associated with the given business entity (vendor) id.
 * Below are the list of services that it talks to:
 * AWSSCMUserManagement (UMS)
 */
import { gql } from '@apollo/client';

import { ActorTypes } from '../../rfxportal/pages/RFXRequest/steps/RFXRequestSuppliersStep/types';
import { User } from './getUsersForBusinessEntityIdQuery';

export const listPrincipalsQuery = gql`
  query listPrincipals($input: TS_ListPrincipalsRequest!) {
    listPrincipals(input: $input) {
        principals {
          type
          id
        }
        continuationToken
      }
    }
`;

export const SMART_PERMISSION_ID = 'Smart_External_User_Access';

export interface PrincipalActor {
  type: ActorTypes;
  id: string
}

export interface ListPrincipalsResult {
  principals: PrincipalActor[];
}

/**
 * Filters a list of users to only include those with smart access.
 *
 * @param fetchedUsers - An array of User objects representing all fetched users.
 * @param actorsWithSmartAccess - An array of PrincipalActor objects representing actors with smart access.
 * @returns An array of User objects that have smart access.
 */
export const getUsersWithSmartAccess = (fetchedUsers: User[], actorsWithSmartAccess: PrincipalActor[]): User[] => {
  const userNamesWithSmartAccess: Set<string> = new Set(actorsWithSmartAccess.map(actor => actor.id));

  return fetchedUsers
    .filter(user => userNamesWithSmartAccess.has(user.username));
}